import React from 'react';

export default function LiveSchedule() {
    return (
        <div
            style={{
                background: 'rgba(255,255,255,0.06)',
                borderRadius: '24px',
                padding: '24px 30px',
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(255,255,255,0.12)',
                borderTop: '6px solid #e67e22',
                boxShadow: '0 25px 60px rgba(0,0,0,0.6)',
                marginBottom: '30px',
                maxWidth: '1350px',
                marginLeft: 'auto',
                marginRight: 'auto',
                overflow: 'hidden',
            }}
        >
            <h3 style={{ marginTop: 0, marginBottom: '18px', color: '#e67e22', fontSize: '1.5rem', display: 'flex', alignItems: 'center', gap: '10px', textTransform: 'uppercase', letterSpacing: '1px' }}>
                📅 Today's Live Schedule
            </h3>

            <div style={{ position: 'relative', overflow: 'hidden', paddingBottom: '10px' }}>
                <style>{`
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .marquee-container {
            display: flex;
            width: max-content;
            animation: marquee 30s linear infinite;
            gap: 12px;
            padding-right: 12px;
          }
          .marquee-container:hover {
            animation-play-state: paused;
          }
          .schedule-card {
            width: 250px;
            flex-shrink: 0;
          }
          
          @media (max-width: 768px) {
            .schedule-card {
              width: 200px;
            }
          }
        `}</style>
                <div className="marquee-container">
                    {[
                        ...[
                            { time: "06:00 - 08:00", category: "Daily Current Affairs" },
                            { time: "08:00 - 10:00", category: "English Vocab / Grammar" },
                            { time: "10:00 - 13:00", category: "Static GK (History/Polity)" },
                            { time: "13:00 - 14:30", category: "Bollywood & Pop Culture" },
                            { time: "14:30 - 17:00", category: "Logical Reasoning / Math" },
                            { time: "17:00 - 19:00", category: "Tech, Gadgets & Sci-Fi" },
                            { time: "19:00 - 20:30", category: "UP/Punjab/Haryana State GK" },
                            { time: "21:00 - 22:00", category: "Mega Mixed Trivia", isLive: true },
                            { time: "22:00 - 00:00", category: "Cricket & Sports" },
                            { time: "00:00 - 06:00", category: "Night Owl Riddles / IQ" }
                        ],
                        ...[
                            { time: "06:00 - 08:00", category: "Daily Current Affairs" },
                            { time: "08:00 - 10:00", category: "English Vocab / Grammar" },
                            { time: "10:00 - 13:00", category: "Static GK (History/Polity)" },
                            { time: "13:00 - 14:30", category: "Bollywood & Pop Culture" },
                            { time: "14:30 - 17:00", category: "Logical Reasoning / Math" },
                            { time: "17:00 - 19:00", category: "Tech, Gadgets & Sci-Fi" },
                            { time: "19:00 - 20:30", category: "UP/Punjab/Haryana State GK" },
                            { time: "21:00 - 22:00", category: "Mega Mixed Trivia", isLive: true },
                            { time: "22:00 - 00:00", category: "Cricket & Sports" },
                            { time: "00:00 - 06:00", category: "Night Owl Riddles / IQ" }
                        ]
                    ].map((item, idx) => {
                        const now = new Date();
                        const istTimeString = now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" });
                        const istTime = new Date(istTimeString);
                        const currentHour = istTime.getHours();
                        const currentMinutes = istTime.getMinutes();
                        const currentTotalMinutes = currentHour * 60 + currentMinutes;

                        const startHour = parseInt(item.time.substring(0, 2));
                        const startMin = parseInt(item.time.substring(3, 5));
                        const startTotal = startHour * 60 + startMin;

                        let endHour = parseInt(item.time.substring(8, 10));
                        let endMin = parseInt(item.time.substring(11, 13));
                        const endTotal = endHour * 60 + endMin;

                        let isActive = false;
                        if (item.time === "22:00 - 00:00") {
                            isActive = currentTotalMinutes >= 22 * 60;
                        } else if (item.time === "00:00 - 06:00") {
                            isActive = currentTotalMinutes >= 0 && currentTotalMinutes < 6 * 60;
                        } else {
                            isActive = currentTotalMinutes >= startTotal && currentTotalMinutes < endTotal;
                        }

                        return (
                            <div key={idx} className="schedule-card" style={{
                                background: item.isLive ? 'rgba(231, 76, 60, 0.2)' : isActive ? 'rgba(46, 204, 113, 0.2)' : 'rgba(0,0,0,0.3)',
                                border: item.isLive ? '1px solid rgba(231, 76, 60, 0.5)' : isActive ? '1px solid rgba(46, 204, 113, 0.5)' : '1px solid rgba(255,255,255,0.05)',
                                padding: '12px 16px',
                                borderRadius: '12px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                boxShadow: (item.isLive || isActive) ? '0 4px 15px rgba(0,0,0,0.2)' : 'none',
                                position: 'relative',
                                overflow: 'hidden'
                            }}>
                                {(isActive || item.isLive) && (
                                    <div style={{
                                        position: 'absolute',
                                        top: 0, left: 0, width: '4px', height: '100%',
                                        background: item.isLive ? '#e74c3c' : '#2ecc71'
                                    }} />
                                )}
                                <div style={{ fontSize: '0.9rem', color: item.isLive ? '#ff7675' : isActive ? '#2ecc71' : '#bdc3c7', fontWeight: 700, marginBottom: '6px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    🕒 {item.time}
                                    {item.isLive && <span style={{ background: '#e74c3c', color: 'white', padding: '2px 6px', borderRadius: '4px', fontSize: '0.7rem', flexShrink: 0 }}>LIVE STREAM</span>}
                                    {isActive && !item.isLive && <span style={{ background: '#2ecc71', color: '#1a1a1a', padding: '2px 6px', borderRadius: '4px', fontSize: '0.7rem', fontWeight: 800, flexShrink: 0 }}>NOW PLAYING</span>}
                                </div>
                                <div style={{ fontSize: '1.05rem', fontWeight: 600, color: (item.isLive || isActive) ? '#fff' : '#ecf0f1', lineHeight: '1.3' }}>
                                    {item.category}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
